import { useMemo } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '@app/hooks';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { selectAppSettings } from '@modules/app';
import { IQT_MODE_ROUTES, ROUTES } from '@constants/routes';
import { GetModelUploaderOptionsArgs } from './types';
import { getModelUploaderOptions } from './helpers';

type UseModelUploaderProps = Omit<GetModelUploaderOptionsArgs, 'dispatch' | 'settings'> & DropzoneOptions;

export function useModelUploader({ initUpload, onDropComplete, ...props }: UseModelUploaderProps) {
    const isRfqUploadWidgetPage = !!useMatch(ROUTES.rfqWidget);
    const isRfqUploadIqtPage = !!useMatch(IQT_MODE_ROUTES.rfqIqt);
    const isRfqUploadPage = isRfqUploadWidgetPage || isRfqUploadIqtPage;

    const dispatch = useAppDispatch();
    const settings = useAppSelector(selectAppSettings);
    const options = useMemo(
        () => getModelUploaderOptions({ dispatch, settings, initUpload, onDropComplete, isRfqUploadPage }),
        [dispatch, settings, initUpload, onDropComplete, isRfqUploadPage],
    );

    return useDropzone({ ...options, ...props });
}
